import { render, staticRenderFns } from "./SpendBudgetPopup.vue?vue&type=template&id=19673ffd&scoped=true"
import script from "./SpendBudgetPopup.vue?vue&type=script&lang=js"
export * from "./SpendBudgetPopup.vue?vue&type=script&lang=js"
import style0 from "./SpendBudgetPopup.vue?vue&type=style&index=0&id=19673ffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19673ffd",
  null
  
)

export default component.exports